<template>
  <b-modal
    id="modal-view"
    size="xl"
    centered
    title="Visualização"
    title-class="font-18"
    hide-footer
  >
    <div class="actions">
      <b-button variant="success" class="mr-2" @click="accept(obj)">
        <i class="fas fa-check"></i>
      </b-button>
      <b-button variant="danger" class="mr-2" @click="deny(obj)">
        <i class="fas fa-times"></i>
      </b-button>
    </div>
    <b-tabs content-class="mt-3">
      <b-tab title="Dados Principais" active>
        <div class="grid-tab">
          <div class="col-12 col-md-12">
            <div v-if="obj.product.seller"
              > <div class="externclass">
                      <div
                        class="classification"
                        :style="setColor(obj.product.seller.classification)"
                      ></div>
                      <p><b>Nome vendedor:</b>{{ obj.product.seller.name }}</p>
                    </div> </div
            >
            <div v-if="obj.product.seller"
              ><b>E-mail vendedor:</b> {{ obj.product.seller.email }}</div
            >
            <div v-if="obj.product.seller"
              ><b>Celular vendedor:</b> {{ obj.product.seller.cellphone }}</div
            >
            <div v-if="obj.product.seller"
              ><b>CPF vendedor:</b> {{ obj.product.seller.cpf_cnpj }}</div
            >
            <hr />
            <div><b>Nome cliente:</b> {{ obj.client.name }}</div>
            <div><b>E-mail cliente:</b> {{ obj.client.email }}</div>
            <div><b>Celular cliente:</b> {{ obj.client.cellphone }}</div>
            <div><b>CPF cliente:</b> {{ obj.client.cpf_cnpj }}</div>
            <hr />
            <div><b>Produto:</b> {{ obj.product.name }}</div>
            <div><b>Valor:</b> R$ {{ formatMoney(obj.total) }}</div>
            <div
              ><b>Método:</b
              >{{
                obj.method == 'CREDIT_CARD' ? 'Cartão de crédito' : obj.method
              }}</div
            >
            <div><b>Data:</b> {{ obj.paid_at | datetime }}</div>
            <a
              class="link"
              rel="noopener noreferrer"
              @click="openModalProduct(obj)"
              >Ver Produto</a
            >
            <hr />
            <div><b>Razão:</b> {{ obj.reason }}</div>
          </div>

          <div>
            <b>Dados da compra e localização - Score, Body</b>
            <div v-if="obj.risk_score"
              ><b>Classificação de Risco:</b> {{ obj.risk_score }}</div
            >
            <hr v-if="obj.risk_body" />
            <div v-if="obj.risk_body && obj.risk_body.ip_address"
              ><b>Nome da Cidade:</b>
              {{ obj.risk_body.ip_address.city.names['pt-BR'] }}</div
            >
            <div v-if="obj.risk_body && obj.risk_body.ip_address"
              ><b>Estado:</b>
              {{ obj.risk_body.ip_address.subdivisions[0].names['pt-BR'] }}</div
            >
            <div v-if="obj.risk_body && obj.risk_body.ip_address"
              ><b>Pais:</b>
              {{
                obj.risk_body.ip_address.registered_country.names['pt-BR']
              }}</div
            >
            <div v-if="obj.risk_body && obj.risk_body.ip_address"
              ><b>Continente:</b>
              {{ obj.risk_body.ip_address.continent.names['pt-BR'] }}</div
            >
            <hr v-if="obj.risk_body" />
            <div v-if="obj.risk_body && obj.risk_body.ip_address"
              ><b>Endereço de IP:</b>
              {{ obj.risk_body.ip_address.traits.ip_address }}</div
            >
            <div v-if="obj.risk_body && obj.risk_body.ip_address"
              ><b>Fornecedor de Internet:</b>
              {{ obj.risk_body.ip_address.traits.isp }}</div
            >
            <hr v-if="obj.risk_body" />
            <div v-if="obj.risk_body && obj.risk_body.ip_address"
              ><b>Latitude:</b>
              {{ obj.risk_body.ip_address.location.latitude }}</div
            >
            <div v-if="obj.risk_body && obj.risk_body.ip_address"
              ><b>Longitude:</b>
              {{ obj.risk_body.ip_address.location.longitude }}</div
            >
            <div v-if="obj.risk_body && obj.risk_body.ip_address"
              ><a
                :href="
                  'https://www.google.com/maps/search/?api=1&query=' +
                  obj.risk_body.ip_address.location.latitude +
                  ',' +
                  obj.risk_body.ip_address.location.longitude
                "
                target="_blank"
                rel="noopener noreferrer"
                >Ver no Google Maps</a
              ></div
            >
            <hr />
            <div v-if="obj.risk_body === null"> Sem Dados de Risco </div>
            <div v-if="obj.risk_body">
              <b-button
                v-if="!jsonList"
                rel="noopener noreferrer"
                variant="success"
                @click="toggleJSON"
                >Ver JSON completo</b-button
              ><b-button
                v-if="jsonList"
                rel="noopener noreferrer"
                variant="success"
                @click="toggleJSON"
                >Fechar JSON</b-button
              ></div
            >
            <JsonViewer
              v-if="jsonList && obj.risk_body"
              :value="obj.risk_body"
            />
          </div>
        </div>
      </b-tab>
      <b-tab title="Compras com esse E-mail" @click="tabs('email')">
        <b-table
          :items="analysis"
          :fields="fields"
          responsive="sm"
          sort-icon-left
        >
          <template v-slot:cell(transaction_id)="data">
            <a :title="data.value">
              {{
                data.value.length >= 10
                  ? data.value.substr(0, 10) + '...'
                  : data.value
              }}
            </a>
          </template>

          <template v-slot:cell(created_at)="data">
            {{ data.value | datetime }}
          </template>

          <template v-slot:cell(type)="data">
            {{ data.value == 'TRANSACTION' ? 'Valor único' : 'Assinatura' }}
          </template>

          <template v-slot:cell(status)="data">
            <b-badge v-if="data.value == 'unpaid'" variant="secondary"
              >Não pago</b-badge
            >
            <b-badge v-if="data.value == 'paid'" variant="success"
              >Pago</b-badge
            >
            <b-badge
              v-if="
                data.value == 'processing' || data.value == 'waiting_payment'
              "
              variant="secondary"
              >Processando</b-badge
            >
            <b-badge
              v-if="data.value == 'refused' || data.value == 'reject'"
              variant="danger"
              >Recusada</b-badge
            >
            <b-badge v-if="data.value == 'refunded'" variant="warning"
              >Reembolsado</b-badge
            >
            <b-badge v-if="data.value == 'chargedback'" variant="dark"
              >Charged Back</b-badge
            >
            <b-badge v-if="data.value == 'trialing'" variant="info"
              >Avaliação</b-badge
            >
          </template>

          <template v-slot:cell(total)="data">
            R$
            {{ formatMoney(data.item.status == 'paid' ? data.value : 0) }}
          </template>

          <template v-slot:cell(balance)="data">
            R$ {{ formatMoney(data.value ? data.value : 0) }}
          </template>

          <template v-slot:cell(antecipation_fee)="data">
            <div v-if="data.value && data.value > 0">
              R$ {{ formatMoney(data.value) }}
              <b-badge v-if="!data.item.antecipated" variant="info"
                >Prévia</b-badge
              >
            </div>
          </template>

          <template v-slot:cell(method)="data">
            <PaymentMethodIcon :method="data.value" />
          </template>
        </b-table>
      </b-tab>
      <b-tab title="Compras com esse Telefone" @click="tabs('cellphone')">
        <b-table
          :items="analysis"
          :fields="fields"
          responsive="sm"
          sort-icon-left
        >
          <template v-slot:cell(transaction_id)="data">
            <a :title="data.value">
              {{
                data.value.length >= 10
                  ? data.value.substr(0, 10) + '...'
                  : data.value
              }}
            </a>
          </template>

          <template v-slot:cell(created_at)="data">
            {{ data.value | datetime }}
          </template>

          <template v-slot:cell(type)="data">
            {{ data.value == 'TRANSACTION' ? 'Valor único' : 'Assinatura' }}
          </template>

          <template v-slot:cell(status)="data">
            <b-badge v-if="data.value == 'unpaid'" variant="secondary"
              >Não pago</b-badge
            >
            <b-badge v-if="data.value == 'paid'" variant="success"
              >Pago</b-badge
            >
            <b-badge
              v-if="
                data.value == 'processing' || data.value == 'waiting_payment'
              "
              variant="secondary"
              >Processando</b-badge
            >
            <b-badge
              v-if="data.value == 'refused' || data.value == 'reject'"
              variant="danger"
              >Recusada</b-badge
            >
            <b-badge v-if="data.value == 'refunded'" variant="warning"
              >Reembolsado</b-badge
            >
            <b-badge v-if="data.value == 'chargedback'" variant="dark"
              >Charged Back</b-badge
            >
            <b-badge v-if="data.value == 'trialing'" variant="info"
              >Avaliação</b-badge
            >
          </template>

          <template v-slot:cell(total)="data">
            R$
            {{ formatMoney(data.item.status == 'paid' ? data.value : 0) }}
          </template>

          <template v-slot:cell(balance)="data">
            R$ {{ formatMoney(data.value ? data.value : 0) }}
          </template>

          <template v-slot:cell(antecipation_fee)="data">
            <div v-if="data.value && data.value > 0">
              R$ {{ formatMoney(data.value) }}
              <b-badge v-if="!data.item.antecipated" variant="info"
                >Prévia</b-badge
              >
            </div>
          </template>

          <template v-slot:cell(method)="data">
            <PaymentMethodIcon :method="data.value" />
          </template>
        </b-table>
      </b-tab>
      <b-tab title="Compras com esse IP" @click="tabs('ip')">
        <b-table
          :items="analysis"
          :fields="fields"
          responsive="sm"
          sort-icon-left
        >
          <template v-slot:cell(transaction_id)="data">
            <a :title="data.value">
              {{
                data.value.length >= 10
                  ? data.value.substr(0, 10) + '...'
                  : data.value
              }}
            </a>
          </template>

          <template v-slot:cell(created_at)="data">
            {{ data.value | datetime }}
          </template>

          <template v-slot:cell(type)="data">
            {{ data.value == 'TRANSACTION' ? 'Valor único' : 'Assinatura' }}
          </template>

          <template v-slot:cell(status)="data">
            <b-badge v-if="data.value == 'unpaid'" variant="secondary"
              >Não pago</b-badge
            >
            <b-badge v-if="data.value == 'paid'" variant="success"
              >Pago</b-badge
            >
            <b-badge
              v-if="
                data.value == 'processing' || data.value == 'waiting_payment'
              "
              variant="secondary"
              >Processando</b-badge
            >
            <b-badge
              v-if="data.value == 'refused' || data.value == 'reject'"
              variant="danger"
              >Recusada</b-badge
            >
            <b-badge v-if="data.value == 'refunded'" variant="warning"
              >Reembolsado</b-badge
            >
            <b-badge v-if="data.value == 'chargedback'" variant="dark"
              >Charged Back</b-badge
            >
            <b-badge v-if="data.value == 'trialing'" variant="info"
              >Avaliação</b-badge
            >
          </template>

          <template v-slot:cell(total)="data">
            R$
            {{ formatMoney(data.item.status == 'paid' ? data.value : 0) }}
          </template>

          <template v-slot:cell(balance)="data">
            R$ {{ formatMoney(data.value ? data.value : 0) }}
          </template>

          <template v-slot:cell(antecipation_fee)="data">
            <div v-if="data.value && data.value > 0">
              R$ {{ formatMoney(data.value) }}
              <b-badge v-if="!data.item.antecipated" variant="info"
                >Prévia</b-badge
              >
            </div>
          </template>

          <template v-slot:cell(method)="data">
            <PaymentMethodIcon :method="data.value" />
          </template>
        </b-table>
      </b-tab>
      <b-tab title="Mensagens do Usuario" @click="tabs('emails')">
        <b-table
          :items="messages"
          :fields="fieldsMessages"
          responsive="sm"
          sort-icon-left
        >
          <template v-slot:cell(created_at)="data">
            {{ data.value | datetime }}
          </template>

          <template v-slot:cell(to_name)="data">
            <b-button
              variant="primary"
              class="mr-2"
              @click="data.toggleDetails"
            >
              <i class="fas fa-eye"></i>
            </b-button>
          </template>

          <template v-slot:row-details="data">
            <div class="grid-details">
              <span>
                <div
                  v-if="
                    data.item.email_delivery_send &&
                    data.item.email_delivery_send.length
                  "
                  class="mb-2"
                >
                  <div><b>E-mail Send:</b></div>
                  <div
                    v-for="send in data.item.email_delivery_send"
                    :key="send.id"
                    class="mb-2"
                  >
                    <div><b>ID:</b> {{ send.id }}</div>
                    <div><b>Data de Criação:</b> {{ send.created_at | datetime }}</div>
                    <div><b>Data de Envio:</b> {{ send.send_at | datetime }}</div>
                  </div>
                </div>

                <hr
                  v-if="
                    data.item.email_open && data.item.email_open.length
                  "
                />

                <div
                  v-if="
                    data.item.email_open &&
                    data.item.email_open.length
                  "
                  class="mb-2"
                >
                  <div><b>E-mail Open:</b></div>
                  <div
                    v-for="open in data.item.email_open"
                    :key="open.id"
                    class="mb-2"
                  >
                    <div><b>ID:</b> {{ open.id }}</div>
                    <div><b>IP:</b> {{ open.ip }}</div>
                    <div><b>Data de Criação:</b> {{ open.created_at | datetime }}</div>
                    <div><b>Data de Envio:</b> {{ open.open_at | datetime }}</div>
                  </div>
                </div>

                <hr
                  v-if="
                    data.item.email_delivery && data.item.email_delivery.length
                  "
                />

                <div
                  v-if="
                    data.item.email_delivery && data.item.email_delivery.length
                  "
                  class="mb-2"
                >
                  <div><b>E-mail Delivery:</b></div>
                  <div
                    v-for="delivery in data.item.email_delivery"
                    :key="delivery.id"
                    class="mb-2"
                  >
                    <div><b>ID:</b> {{ delivery.id }}</div>
                    <div><b>Data de Crição:</b> {{ delivery.created_at | datetime }}</div>
                    <div><b>Data de Envio:</b> {{ delivery.delivery_at | datetime }}</div>
                    <div><b>Resposta:</b> {{ delivery.response }}</div>
                    <div><b>IP:</b> {{ delivery.ip }}</div>
                  </div>
                </div>

                <hr
                  v-if="data.item.email_bounce && data.item.email_bounce.length"
                />

                <div
                  v-if="data.item.email_bounce && data.item.email_bounce.length"
                  class="mb-2"
                >
                  <div><b>E-mail Bounce:</b></div>
                  <div
                    v-for="bounce in data.item.email_bounce"
                    :key="bounce.id"
                    class="mb-2"
                  >
                    <div><b>ID:</b> {{ bounce.id }}</div>
                    <div><b>Data de Crição:</b> {{ bounce.created_at | datetime }}</div>
                    <div><b>Motivo:</b> {{ bounce.reason }}</div>
                  </div>
                </div>

                <hr
                  v-if="data.item.email_click && data.item.email_click.length"
                />

                <div
                  v-if="data.item.email_click && data.item.email_click.length"
                  class="mb-2"
                >
                  <div><b>E-mail Click:</b></div>
                  <div
                    v-for="click in data.item.email_click"
                    :key="click.id"
                    class="mb-2"
                  >
                    <div><b>ID:</b> {{ click.id }}</div>
                    <div><b>Data de Crição:</b> {{ click.created_at | datetime }}</div>
                  </div>
                </div>
              </span>

              <span>
                <div
                  v-if="
                    data.item.whatsapp_sent && data.item.whatsapp_sent.length
                  "
                  class="mb-2"
                >
                  <div><b>WhatsApp Sent:</b></div>
                  <div
                    v-for="sendwpp in data.item.whatsapp_sent"
                    :key="sendwpp.id"
                    class="mb-2"
                  >
                    <div><b>ID:</b> {{ sendwpp.id }}</div>
                    <div><b>Data de Envio:</b> {{ sendwpp.send_at | datetime }}</div>
                    <div><b>ID GWhats:</b> {{ sendwpp.gwhats_id }}</div>
                  </div>
                </div>

                <hr
                  v-if="
                    data.item.whatsapp_delivery &&
                    data.item.whatsapp_delivery.length
                  "
                />

                <div
                  v-if="
                    data.item.whatsapp_delivery &&
                    data.item.whatsapp_delivery.length
                  "
                  class="mb-2"
                >
                  <div><b>WhatsApp Delivery:</b></div>
                  <div
                    v-for="deliverywpp in data.item.whatsapp_delivery"
                    :key="deliverywpp.id"
                    class="mb-2"
                  >
                    <div><b>ID:</b> {{ deliverywpp.id }}</div>
                    <div
                      ><b>Data de Crição:</b> {{ deliverywpp.created_at | datetime }}</div
                    >
                  </div>
                </div>

                <hr
                  v-if="
                    data.item.whatsapp_click && data.item.whatsapp_click.length
                  "
                />

                <div
                  v-if="
                    data.item.whatsapp_click && data.item.whatsapp_click.length
                  "
                  class="mb-2"
                >
                  <div><b>WhatsApp Click:</b></div>
                  <div
                    v-for="clickwpp in data.item.whatsapp_click"
                    :key="clickwpp.id"
                    class="mb-2"
                  >
                    <div><b>ID:</b> {{ clickwpp.id }}</div>
                    <div><b>Data de Crição:</b> {{ clickwpp.created_at | datetime }}</div>
                  </div>
                </div>

                <hr
                  v-if="
                    data.item.whatsapp_bounce &&
                    data.item.whatsapp_bounce.length
                  "
                />

                <div
                  v-if="
                    data.item.whatsapp_bounce &&
                    data.item.whatsapp_bounce.length
                  "
                  class="mb-2"
                >
                  <div><b>WhatsApp Bounce:</b></div>
                  <div
                    v-for="bouncewpp in data.item.whatsapp_bounce"
                    :key="bouncewpp.id"
                    class="mb-2"
                  >
                    <div><b>ID:</b> {{ bouncewpp.id }}</div>
                    <div><b>Data de Crição:</b> {{ bouncewpp.created_at | datetime }}</div>
                  </div>
                </div>
              </span>
            </div>
          </template>
        </b-table>

        <div v-if="messages.length > 0" class="row">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>

        <div
          v-if="messages.length == 0 && !loading"
          class="row justify-content-center"
        >
          <div class="alert alert-primary" role="alert">
            Sem Mensagens enviadas.
          </div>
        </div>
      </b-tab>
    </b-tabs>

    <div v-if="loading" class="row justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <ModalDetails v-if="canShowProductHistory" :product-id="obj.product.id" :data-user="dataUser" :type="stateToProduct" />
  </b-modal>
</template>

<script>
import Money from '@src/mixins/money'
import JsonViewer from 'vue-json-viewer'
import ModalDetails from '../../router/views/products/modal-details.vue'
import AnalysisService from '@services/resources/AnalysisService'
import MessagesService from '@services/resources/MessagesService'
import {AccessLevel} from "@views/configurations/enums/accessLevel";
var serviceMessage = MessagesService.build()
var service = AnalysisService.build()

export default {
  components: { JsonViewer, ModalDetails },
  mixins: [Money],
  props: {
    obj: {
      type: Object,
    },
    id: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      currentPage: 1,
      totalRows: 1,
      stateToProduct: 'analisy',
      jsonList: false,
      users: [],
      dataUser: [],
      analysis: [],
      messages: [],
      sortBy: 'name',
      sortDesc: false,
      fields: [
        { key: 'transaction_id', label: 'ID Pagarme', sortable: true },
        { key: 'id', label: 'ID Greenn', sortable: true },
        { key: 'created_at', label: 'Data', sortable: false },
        { key: 'type', label: 'Tipo', sortable: true },
        { key: 'status', label: 'Status', sortable: false },
        { key: 'total', label: 'Valor Greenn', sortable: true },
        { key: 'method', label: 'Método', sortable: false },
        { key: 'antecipation_fee', label: 'Antecipação', sortable: false },
      ],
      fieldsMessages: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'created_at', label: 'Data' },
        { key: 'type', label: 'Tipo' },
        { key: 'title', label: 'Titulo' },
        { key: 'system', label: 'Sistema' },
        { key: 'to_address', label: 'E-mail' },
        { key: 'email_click_count', label: 'Click E-mail' },
        { key: 'whatsapp_click_count', label: 'Click Whats' },
        { key: 'to_name', label: 'Detalhes' },
      ],
      typeAnalysis: 'email',
      teste1: 0.13,
      teste: {
        id: '45dd9a68-a360-4d7e-84ee-aceeeba64393',
        email: {
          domain: { first_seen: '2019-01-01' },
          is_free: true,
          first_seen: '2021-10-05',
          is_high_risk: false,
          is_disposable: false,
        },
        ip_address: {
          city: {
            names: {
              de: 'Niterói',
              en: 'Niterói',
              es: 'Niterói',
              fr: 'Niterói',
              ja: 'ニテロイ',
              ru: 'Нитерой',
              'pt-BR': 'Niterói',
            },
            confidence: 90,
            geoname_id: 3456283,
          },
          risk: 0.01,
          postal: { code: '24000', confidence: 1 },
          traits: {
            isp: 'Claro NET',
            domain: 'virtua.com.br',
            network: '186.223.183.64/26',
            user_type: 'residential',
            ip_address: '186.223.183.105',
            organization: 'Claro NET',
            static_ip_score: 23.8,
            autonomous_system_number: 28573,
            autonomous_system_organization: 'CLARO S.A.',
          },
          country: {
            names: {
              de: 'Brasilien',
              en: 'Brazil',
              es: 'Brasil',
              fr: 'Brésil',
              ja: 'ブラジル連邦共和国',
              ru: 'Бразилия',
              'pt-BR': 'Brasil',
              'zh-CN': '巴西',
            },
            iso_code: 'BR',
            confidence: 99,
            geoname_id: 3469034,
            is_high_risk: false,
          },
          location: {
            latitude: -22.9201,
            longitude: -43.0811,
            time_zone: 'America/Sao_Paulo',
            local_time: '2021-10-05T20:39:12-03:00',
            accuracy_radius: 10,
          },
          continent: {
            code: 'SA',
            names: {
              de: 'Südamerika',
              en: 'South America',
              es: 'Sudamérica',
              fr: 'Amérique du Sud',
              ja: '南アメリカ',
              ru: 'Южная Америка',
              'pt-BR': 'América do Sul',
              'zh-CN': '南美洲',
            },
            geoname_id: 6255150,
          },
          subdivisions: [
            {
              names: {
                en: 'Rio de Janeiro',
                es: 'Río de Janeiro',
                'pt-BR': 'Rio de Janeiro',
              },
              iso_code: 'RJ',
              confidence: 99,
              geoname_id: 3451189,
            },
          ],
          registered_country: {
            names: {
              de: 'Brasilien',
              en: 'Brazil',
              es: 'Brasil',
              fr: 'Brésil',
              ja: 'ブラジル連邦共和国',
              ru: 'Бразилия',
              'pt-BR': 'Brasil',
              'zh-CN': '巴西',
            },
            iso_code: 'BR',
            geoname_id: 3469034,
          },
        },
        risk_score: 1.55,
        credit_card: {
          type: 'credit',
          brand: 'Mastercard',
          issuer: { name: 'Santander' },
          country: 'BR',
          is_prepaid: false,
          is_virtual: false,
          is_business: false,
          is_issued_in_billing_address_country: true,
        },
        billing_address: {
          latitude: -23.5477,
          longitude: -46.6358,
          is_in_ip_country: true,
          distance_to_ip_location: 370,
        },
        funds_remaining: 4.355,
        queries_remaining: 290,
      },
    }
  },
  watch: {
    currentPage() {
      this.fetchUsers()
    },
  },
  methods: {
    accept(e) {
      this.$emit('accept', this.id)
    },
    deny(e) {
      this.$emit('deny', this.id)
    },
    tabs(a) {
      if (a === 'emails' || a === 'mensage') {
        this.typeAnalysis = a
        this.fetchMenssages()
        return
      }
      this.typeAnalysis = a
      this.fetchAnalysis()
    },
    fetchMenssages() {
      this.loading = true
      this.messages = []

      let data = {
        page: this.currentPage,
        to_address: this.obj.client.email,
      }

      serviceMessage
        .search(data)
        .then((resp) => {
          console.log(resp)
          this.messages = resp.data
          this.currentPage = resp.current_page
          this.totalRows = resp.last_page
          this.loading = false
        })
        .catch((err) => {})
    },
    setColor(type) {
      if (type) {
        if (type === 'green') {
          return 'background: #00E4A0'
        }
        if (type === 'yellow') {
          return 'background: #fff700'
        }
        if (type === 'red') {
          return 'background: #FF0A44'
        }
        if (type === 'black') {
          return 'background: #000000'
        }
      }else{
          return 'background:#c7c7c7;';
      }
    },
    fetchAnalysis() {
      this.loading = true
      this.analysis = []

      service
        .read(this.id + '/sale?with=' + this.typeAnalysis)
        .then((resp) => {
          console.log(resp)
          this.analysis = resp
          this.loading = false
        })
        .catch((err) => {})
    },
    openModalProduct(data) {
      this.dataUser = data.product
      this.$bvModal.show('details')
    },
    toggleJSON() {
      if (this.jsonList) {
        this.jsonList = false
      } else {
        this.jsonList = true
      }
    },
  },
  computed: {
    canShowProductHistory() {
      return this.$canAction('products_show_change_history', AccessLevel.READER);
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-tab {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}

.link {
  color: #00897b !important;
  text-decoration: none !important;
  background-color: transparent !important;
  cursor: pointer;
}

.link:hover {
  color: #006359 !important;
}

.actions {
  text-align: end;
}

.grid-details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
</style>